import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../global.service';
import { Service } from 'src/app/services';
@Component({
  selector: 'app-pop-channels',
  templateUrl: './pop-channels.component.html',
  styleUrls: ['./pop-channels.component.sass']
})
export class  PopChannelsComponent implements OnInit {
  public channels: number = 0;
  public allChannels: any = [];
  public planId: number = 0;
  public planName: string = '';
  public idAddOn:number=0;
  constructor(private services: Service, public global: GlobalService, private router: Router, public dialog: MatDialog, public matDialogRef: MatDialogRef<PopChannelsComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private route: ActivatedRoute, private loadingScreenService: LoadingScreenService) {
    if (data.planId != null) {
      this.planId = data.planId;
      if(data.planName.length>0){
        this.planName= ": "+ data.planName;
      }
    }
    if (data.idAddOn != null) {
      this.idAddOn = data.idAddOn;
    }
  }
  ngOnInit() {
    this.loadingScreenService.startLoading();
    if (this.planId == 0) {
      this.services.channelsFull(sessionStorage.getItem("token")).subscribe((data: any) => {
        this.loadingScreenService.stopLoading();
        this.allChannels = data;
      });
    }
    else{
      this.services.channelsList(sessionStorage.getItem("token"),this.planId,this.idAddOn, 100).subscribe((data: any) => {
        this.loadingScreenService.stopLoading();
        this.allChannels = data;
      });
    }
  }
  continue() {
    this.matDialogRef.close('accept');
  }
  public close(msg: string) {
    this.matDialogRef.close('cancel');
  }
}
